import { CheckboxChecked, CheckboxUnchecked } from '@/resources/assets/images';
import classNames from 'classnames';
import React, { ButtonHTMLAttributes } from 'react';

interface CheckboxWithIconProps
	extends ButtonHTMLAttributes<HTMLButtonElement> {
	checked: boolean;
	color?: 'yellow' | 'white';
	onToggle?: (value: boolean) => void;
	className?: string;
}

export default function CheckboxWithIcon({
	checked,
	color = 'white',
	className,
	onToggle = () => {},
	...props
}: CheckboxWithIconProps) {
	return (
		<button
			className={classNames(
				'h-full w-full',
				{
					'text-orange': color === 'yellow',
					'text-white': color === 'white'
				},
				className
			)}
			onClick={() => onToggle(!checked)}
			{...props}
		>
			{!checked ? (
				<CheckboxUnchecked className="h-full w-full" />
			) : (
				<CheckboxChecked className="h-full w-full" />
			)}
		</button>
	);
}
